if (!customElements.get('mint-real-life-slider')) {
  customElements.define(
    'mint-real-life-slider',
    class MintRealLifeSlider extends HTMLElement {
      connectedCallback() {
        this.sliderElement = this.querySelector('.mint-real-life__cards');
        this.scrollbarElement = this.querySelector('.mint-real-life__scrollbar');
        this.mobileQuery = window.matchMedia('(max-width: 767px)');
        this.handleBreakpoint = this.handleBreakpoint.bind(this);

        this.mobileQuery.addEventListener('change', this.handleBreakpoint);
        this.handleBreakpoint();
      }

      disconnectedCallback() {
        this.mobileQuery?.removeEventListener('change', this.handleBreakpoint);
        this.clearSwiperWait();
        this.destroySlider();
      }

      handleBreakpoint() {
        if (this.mobileQuery.matches) {
          this.createSlider();
        } else {
          this.destroySlider();
        }
      }

      createSlider() {
        if (this.slider || !this.sliderElement) return;

        if (typeof Swiper !== 'function') {
          this.waitForSwiper();
          return;
        }

        this.clearSwiperWait();

        this.slider = new Swiper(this.sliderElement, {
          slidesPerView: 1.09,
          spaceBetween: 0,
          speed: 400,
          grabCursor: true,
          watchOverflow: true,
          scrollbar: {
            el: this.scrollbarElement,
            draggable: true,
          },
        });
      }

      waitForSwiper() {
        if (this.swiperWaitTimer) return;

        let attempts = 0;
        this.swiperWaitTimer = window.setInterval(() => {
          attempts += 1;

          if (typeof Swiper === 'function') {
            this.clearSwiperWait();
            if (this.mobileQuery.matches) this.createSlider();
          } else if (attempts === 200) {
            this.clearSwiperWait();
          }
        }, 50);
      }

      clearSwiperWait() {
        if (!this.swiperWaitTimer) return;

        window.clearInterval(this.swiperWaitTimer);
        this.swiperWaitTimer = null;
      }

      destroySlider() {
        this.clearSwiperWait();
        if (!this.slider) return;

        this.slider.destroy(true, true);
        this.slider = null;
      }
    },
  );
}
